import React, { useCallback, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import styles from '../../../manage-participants/styles.module.scss';
import { FormattedMessage } from 'react-intl';
import { SubscriptionRequiredModal } from '../../../../pages';
import InviteReceivingTeamFormik from '../../../../forms/InviteReceivingTeamFormContainer';
import { useTeamInfo } from '../../../../team-id-context';
import { useUserDealRestrictions } from '../../../../auth/user-restrictions';
import { TitleFormattedMessage } from '../../../titleFormattedMessage';
import PropdocsModal from '../../../modal/PropdocsModal';

interface EmptyCounterpartyProps {
  canInvite: boolean;
  refreshCounterpartyData: () => void;
}

// Styled container for form actions - right-aligned buttons
const ActionsContainer = React.memo(({ children }: { children?: React.ReactNode }) => (
  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1.5rem' }}>
    {children}
  </div>
));

const EmptyCounterparty = ({ canInvite, refreshCounterpartyData }: EmptyCounterpartyProps) => {
  const [showSubscriptionRequiredModal, setSubscriptionRequiredModal] = useState(false);
  const [showInviteCounterpartyModal, setShowInviteCounterpartyModal] = useState(false);

  const invitationIsSent = useCallback(() => {
    setShowInviteCounterpartyModal(false);
  }, []);
  const { canInviteCounterparty } = useUserDealRestrictions();

  const { teamId } = useTeamInfo();
  const handleInviteCounterpartyButton = canInviteCounterparty
    ? () => setShowInviteCounterpartyModal(true)
    : () => setSubscriptionRequiredModal(true);

  return (
    <>
      <Container className="pl-4 pr-4 flex-row text-center">
        <p className="mb-2">
          No counterparty has <br />
          been invited yet.
        </p>
        {canInvite && (
          <Button
            variant="primary"
            onClick={handleInviteCounterpartyButton}
            className={styles.handleParticipantsButton}
          >
            <TitleFormattedMessage id="cta.invite-counterparty" defaultMessage="Invite Counterparty" />
          </Button>
        )}
      </Container>
      <PropdocsModal
        show={showInviteCounterpartyModal}
        setShow={() => setShowInviteCounterpartyModal(false)}
        size="lg"
        title={
          <header className={styles.invitationModal__title}>
            <FormattedMessage id="title.add-team-member" defaultMessage="Invite Counterparty to the Deal" />
          </header>
        }
      >
        <InviteReceivingTeamFormik
          bodyContainer={React.Fragment}
          actionsContainer={ActionsContainer}
          renderSecondaryAction={() => (
            <Button variant="link" className="text-secondary" onClick={() => setShowInviteCounterpartyModal(false)}>
              <TitleFormattedMessage id="cta.cancel" defaultMessage="Cancel" />
            </Button>
          )}
          sendDocumentToReceiverHandler={() => {}}
          onSuccess={invitationIsSent}
          teamId={teamId}
          sendWithDocumentId={false}
          shareDocument={false}
          refreshCounterpartyData={refreshCounterpartyData}
        />
      </PropdocsModal>
      <SubscriptionRequiredModal
        isOpen={showSubscriptionRequiredModal}
        onClose={() => setSubscriptionRequiredModal(false)}
      />
    </>
  );
};

export default EmptyCounterparty;
